/**
 * Builds the survey route with the url the survey view should return to once
 * it has been completed. The survey view resolves `query.redirect` after the
 * backend `redirectUrl`, so `returnTo` must be url-encoded to survive query
 * strings inside it.
 */
export function buildSurveyPath(surveyId: number, returnTo: string): string {
  return `/survey/${surveyId}?redirect=${encodeURIComponent(returnTo)}`
}
